module.exports = __webpack_public_path__ + "media/images/shared/icon_shopping_white-797a8125a150757ea262e815e99eca6d.png";